import algoliasearch from 'algoliasearch';
import instantsearch from 'instantsearch.js';
import customPagination from './pagination';
import customHits from './hits';
import customSearchBox from './searchBox';
import customRefinementList from './refinementList';
import customStats from './stats';
import {configure} from 'instantsearch.js/es/widgets';

let gamme = getGamme();
let famille = getFamille();
let filtres = getFiltres();
let apiIdentifiant = getApiIdentifiant();
let attributGamme = getAttributGamme();
let attributFamille = getAttributFamille();

const searchClient = algoliasearch(apiIdentifiant.appId, apiIdentifiant.searchKey);
const search = instantsearch({
    indexName: 'Produits',
    searchClient,
    searchFunction: function(helper) {
        // ? Affiche seulement les objets de la FAMILLE de la page en cours
        if(helper.state.disjunctiveFacets.includes('famille') === false && famille !== null){
          helper.state.disjunctiveFacets.push('famille');
          helper.addDisjunctiveFacetRefinement('famille', famille);
        }

          // ? Affiche seulement les objets de la GAMME de la page en cours
        if(helper.state.disjunctiveFacets.includes('gamme') === false && gamme != null){
          helper.state.disjunctiveFacets.push('gamme');
          helper.addDisjunctiveFacetRefinement('gamme', gamme);
        }
        helper.search();
      },
});

let widgetParameters = [
  // Permet de pré filtrer avec les attributs
  configure({
    filters: formatFiltres(filtres) 
  }),
  // Permet de modifier la barre de recherche
  customSearchBox({
      container: document.querySelector('#barreRechercheBlock'),
  }),
  // Permet de modifier les résultats de recherche
  customHits({
      container:  document.querySelector('#algolia_result'),
      transformItems: function(items){
          return transformItems(items)
      }
  }),
  // Permet de modifier la pagination
  customPagination({
      container: document.querySelector('#pagination_produit')
  }),
  // Permet d'afficher le nombre de produit
  customStats({
    container: document.querySelector('#produit_compteur'),
  })
];
// condition selon les attributs choisis
// il n'y a aucun attribut selectionné
if ((attributFamille == null && attributGamme == null)) {
  let refinement = customRefinementList({
    container: document.querySelector('#gammeFiltre'),
    attribute: "gamme",
    limit: 50,
    sortBy: ['gamme:asc'],
    attributeLabel: "Gamme",
    filtres: filtres.gamme
  });
  widgetParameters.push(refinement);
  // il y a  l'attribut gamme selectionné
} else if (attributFamille == null && attributGamme != null) {
  let refinement = customRefinementList({
    container: document.querySelector('#familleFiltre'),
    attribute: "famille",
    limit: 50,
    sortBy: ['famille:asc'],
    attributeLabel: "Famille",
    filtres: filtres.famille
  });
  widgetParameters.push(refinement);
  // il y a  l'attribut famille selectionné
} else if (attributFamille != null && attributGamme == null) {
  let refinement = customRefinementList({
    container: document.querySelector('#sousFamilleFiltre'),
    attribute: "sous_famille",
    limit: 50,
    sortBy: ['sous_famille:asc'],
    attributeLabel: "Sous Famille",
    filtres: filtres.sousFamille
  });
  widgetParameters.push(refinement);
  // il y a  les 2 attributs selectionnés
} else {
  let refinement = customRefinementList({
    container: document.querySelector('#sousFamilleFiltre'),
    attribute: "sous_famille",
    limit: 50,
    sortBy: ['score:asc', 'sous_famille:asc'],
    attributeLabel: "Sous Famille",
    filtres: filtres.sousFamille
  });
  widgetParameters.push(refinement);
}

search.addWidgets(widgetParameters);
search.start();


function transformItems(items)
{

  items.map(function(item){
    if(item.hasOwnProperty('illustration') === true) return item;
    
    item.illustration = getIllustration(item.objectID);

    return item;
  });

  return items;
}


/**
 * retourne les identifiant de l'api d'algolia, parametrable via le backoffice
 * @return {object|null}
 */
function getApiIdentifiant()
{
  let algoliaAppId = $('.contenuPage').data('algolia-app-id');
  let algoliaSearchKey = $('.contenuPage').data('algolia-search-key');

  if(algoliaAppId.length === 0 || algoliaSearchKey.length === 0) return null;

  return {
    "appId": algoliaAppId,
    "searchKey": algoliaSearchKey
  }
}

/**
 * @return {string|null}
 */
function getGamme()
{
  let gamme = $('.contenuPage').data('gamme');

  if(gamme.length === 0) return null;

  return gamme;
}

/**
 * @return {string|null}
 */
function getFamille()
{
  let famille = $('.contenuPage').data('famille');

  if(famille.length === 0) return null;

  return famille;
}

/**
 * @param {string}
 * @return {string}
 */
function getIllustration(objectId)
{
  // Recupere la liste des illustrations
  let illustrations = $('.contenuPage').data('produit-image');

  // Selectionner la bonne illustration pour l'objet express passé en parametre
  let item = illustrations.find(function(item){
    if(item.id == objectId) {
      return item;
    }
  });

  // Si aucune illustration n'a été trouvé, retourner l'image par defaut
  if(item === undefined){
    let themePath = $('.contenuPage').data('theme-path');
    return themePath + '/img/photos/image-default.svg';
  }

  return item.illustration
}

/**
 * Les Filtres
 * permet de recupérer filtres
 */
 function getFiltres()
 {
     let filtres = $('.contenuPage').data('filtres');
     return filtres;
 }


 /**
 * Les filtres formatés pour le filters
 * @return array
 * permet de recupérer filtres formatés pour la mise en place du filters
 */
function formatFiltres(filtres){
  let filtresTab = [];
  //mode de consommation
  if(getFamille() != null){
      let filtreFamille = formatFiltresParFacet(filtres.famille, 'famille');
      filtresTab.push(filtreFamille);
  }
  
  //saison 
  if(getGamme() != null){
      let filtreGamme = formatFiltresParFacet(filtres.gamme, 'gamme');
      filtresTab.push(filtreGamme);
  }
 

  let filtresFormat = filtresTab.join(' AND ');
  return filtresFormat;
}
/**
* le filtre formaté pour le filters
* @return array
* permet de recupérer chaque filtre formatés pour la mise en place du filters
*/
function formatFiltresParFacet(filtres, nomFacet){
  let tab = [];
      filtres.forEach(filtre => {
          if(filtre.indexOf("'") >= 0 ){
              let echap = "\\";
              let position = filtre.indexOf("'");
              filtre = [filtre.slice(0,position), echap, filtre.slice(position)].join('');
          }
          if(filtre.indexOf(' ') >= 0){
              tab.push(nomFacet.concat(':',"'"+filtre+"'"));
          }else{
              tab.push(nomFacet.concat(':',filtre));
          }
      });    
      let filtreFormate = tab.join(' OR ');
 return filtreFormate;
}

/**
 * @return {string|null}
 */
 function getAttributGamme()
 {
   let gamme = $('.contenuPage').data('attribut-gamme');
 
   if(gamme.length === 0) return null;
 
   return gamme;
 }

 /**
 * @return {string|null}
 */
function getAttributFamille()
{
  let famille = $('.contenuPage').data('attribut-famille');

  if(famille.length === 0) return null;

  return famille;
}




